module.exports = __webpack_public_path__ + "img/terroir-redshift-3-mobile.09581ca3.jpg";